export default {
  en: {
    contentCampaign: 'Content campaigns',
    operationalReporting: 'Booking and service reports',
    read: 'View',
    manage: 'Manage configuration',
    publish: 'Publish and control display',
    report: 'View reports',
    export: 'Export reports',
  },
  ar: {
    contentCampaign: 'حملات المحتوى',
    operationalReporting: 'تقارير الحجز والخدمات',
    read: 'عرض',
    manage: 'إدارة الإعدادات',
    publish: 'نشر والتحكم في العرض',
    report: 'عرض التقارير',
    export: 'تصدير التقارير',
  },
}
